import { UrlObject } from "url";
import { pagesPath } from "faqSrc/lib/$path";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import styled from "styled-components";
import IconWrite from "~/components/icons/IconWrite";
import { QuestionAnswer } from "~/models/questionAnswer";
import { Topic } from "~/models/topic";

interface Props {
  buttonId?: string;
  onClick?: () => void;
  questionAnswerId: QuestionAnswer["id"];
  topicSlug: Topic["slug"];
  url?: UrlObject;
}

export const HOW_TO_REVIEW_VISITED_STORE_KEY = "_qa_how_to_review_visited";

const UserReactionWriteCommentButton: React.FC<Props> = ({
  buttonId,
  onClick,
  questionAnswerId,
  topicSlug,
  url,
}) => {
  const { t } = useTranslation();
  return (
    <Link
      href={
        url ??
        pagesPath.qa
          ._topicSlug(topicSlug)
          ._questionAnswerId(questionAnswerId)
          .howToReview.$url()
      }
      passHref
    >
      <WriteCommentButton
        className="writeCommentButton"
        id={buttonId}
        onClick={onClick}
      >
        <IconWrite size={18} />
        <span>{t("common:button.write-a-comment")}</span>
      </WriteCommentButton>
    </Link>
  );
};

const WriteCommentButton = styled.a`
  align-items: center;
  background: var(--body-bg-clr);
  border: 1px solid var(--cap-clr);
  border-radius: 5px;
  color: var(--cap-clr);
  display: grid;
  font-size: 13px;
  gap: 6px;
  grid-template-columns: 18px auto;
  padding: 0 12px;

  &:hover {
    background: var(--box-bdr-clr);
    text-decoration: underline;
  }
`;

export default UserReactionWriteCommentButton;
